import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import classNames from 'classnames';

import { Dropzone } from 'Components';
import { FieldEnum } from 'Common/FieldEnum';
import { Formatters } from 'Common/Helpers';
import { ImagePreview } from 'Common/ImagePreview';
import {
  STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE,
  STUDENT_IMAGE_STATUS_DISPLAY_IMAGE,
  STUDENT_IMAGE_STATUS_DISPLAY_PREVIEW,
  STUDENT_IMAGE_STATUS_DISPLAY_STOCK_PREVIEW,
  ACCEPTED_IMAGE_TYPES,
} from 'Common/Constants/';
import { createToast, toastType } from 'Common/ToastHelper';

const FigureComponent = ({ children, className = '' }) => (
  <figure className={`student-form--student-image ${className}`}>
    {children}
  </figure>
);

const renderComponent = ({
  status,
  imagePreview,
  studentImage,
  removePreview,
  changeImage,
  changeStudentImage,
}) => {
  switch (status) {
    /**
     * Display a preview of the image.
     * Only supports certain image types.
     */
    case STUDENT_IMAGE_STATUS_DISPLAY_PREVIEW:
      return (
        <FigureComponent>
          {imagePreview && (
            <ImagePreview
              className="student-form--image-preview-wrapper"
              file={imagePreview}
            />
          )}
          <figcaption>
            <Button
              className={`student-form--remove-image-preview`}
              onClick={removePreview}
            >
              Remove Preview
            </Button>
          </figcaption>
        </FigureComponent>
      );
    /**
     * Show the student image from the DB
     */
    case STUDENT_IMAGE_STATUS_DISPLAY_IMAGE:
      return (
        <FigureComponent>
          <img
            src={Formatters.prependBase64(studentImage)}
            alt="Student Profile"
          />
          <figcaption>
            <Button onClick={changeStudentImage}>Change</Button>
          </figcaption>
        </FigureComponent>
      );
    case STUDENT_IMAGE_STATUS_DISPLAY_STOCK_PREVIEW:
      return (
        <FigureComponent>
          <span className="student-form--image-stock">
            <Icon name="user" size="massive" />
          </span>
        </FigureComponent>
      );
    default:
      return null;
  }
};

export const StudentImage = props => {
  const { status, onDrop } = props;

  const className = classNames(
    'file--dropzone student-form--dropzone',
    'file--dropzone-limited-width',
    {
      'file--dropzone-hidden': status !== STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE,
    }
  );

  return (
    <div className="student-form--student-image-wrapper">
      {renderComponent(props)}
      <Dropzone
        accept={ACCEPTED_IMAGE_TYPES.join(',')}
        activeClassName="file--dropzone--active"
        rejectClassName="file--dropzone--error"
        className={className}
        multiple={false}
        name={FieldEnum.StudentInfoImagePreview}
        onDrop={onDrop}
        onDropRejected={() => {
          createToast(
            toastType.error,
            'Error',
            `Supported image types: ${ACCEPTED_IMAGE_TYPES.join(', ')}`
          );
        }}
      >
        <p>
          Drag and drop the image file here <br />
          <small>or double click to select image</small>.
        </p>
      </Dropzone>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/StudentImage.js